import { render } from "./BattlesBoxElement.vue?vue&type=template&id=0f38517e&scoped=true"
import script from "./BattlesBoxElement.vue?vue&type=script&lang=js"
export * from "./BattlesBoxElement.vue?vue&type=script&lang=js"

import "./BattlesBoxElement.vue?vue&type=style&index=0&id=0f38517e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f38517e"]])

export default __exports__